import { acceptableCancelCodesForRewrite } from '@ourbranch/lookups';

export const isPolicyEligibleForRewrite = (policy, canRewritePolicy) => {
  // Already rewritten: rewritePolicy refuses a second rewrite of the same policy (#36661).
  if (!canRewritePolicy || policy?.rewrittenToPolicyId) {
    return false;
  }
  const flatCancel = policy?.effectiveDate === policy?.endDate;
  const firstTerm = policy?.term === 1;
  return firstTerm && flatCancel && acceptableCancelCodesForRewrite.includes(policy?.cancelReason);
};
